/**
 * Reads a generator's gallery preview (`_opgUnit.gallery`) from untrusted document data.
 *
 * Returns null unless there is something to show: a positive photo count AND a thumbnail
 * path. Anything malformed (a string count, a missing path) is treated as no gallery, so a
 * preview renders nothing rather than a broken tile.
 */
import type { GalleryPreviewSummary } from '../../types/fieldService/generatorPhotos';

function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

export function readGalleryPreview(doc: unknown): GalleryPreviewSummary | null {
  if (!isRecord(doc) || !isRecord(doc._opgUnit) || !isRecord(doc._opgUnit.gallery)) return null;
  const { count, primaryThumbPath, primaryPhotoId } = doc._opgUnit.gallery;
  if (typeof count !== 'number' || !Number.isFinite(count) || count <= 0) return null;
  if (typeof primaryThumbPath !== 'string' || primaryThumbPath.length === 0) return null;
  return {
    count,
    primaryThumbPath,
    primaryPhotoId: typeof primaryPhotoId === 'string' && primaryPhotoId ? primaryPhotoId : null,
  };
}
